export default __webpack_public_path__ + "static/media/LAS0720.34I-37964_-22246_0.43f8c540.jpg";